import dispatcher from '../dispatcher';
import pageStore from '../page/page.store';
import pageLoadStore from '../page-load/page-load.store';
import popupStore from '../popup/popup.store';
import * as cookieUtils from '../utils/cookieUtils';

var elementProto = Object.create(HTMLElement.prototype);

var _handleDispatcher = function(e) {
	var pw = document.getElementsByClassName('page-wrapper')[0];
	if (e.type === 'router:route') {
		clearTimeout(this._to);
		pw.classList.remove('p404-active');
	}
	if (e.type === 'main-stage:ready') {
		if (!this.mainStageReady) {
			this.mainStageReady = true;
			this.handlePageChange();
		}
	}
}

var _handlePopup = function() {
	// clearTimeout(this._to);
}

var _findByDataId = function(tag, id, is) {
	var elements;
	var result = null;

	if (is) {
		elements = document.querySelectorAll(tag.split(':')[0]
			+ '[is=' + tag.split(':')[1] + ']');
	} else {
		elements = document.getElementsByTagName(tag);
	}

	Array.prototype.forEach.call(elements, function(el) {
		if (el.getAttribute('data-id') === id) {
			result = el;
		}
	});

	return result;
}

var _handlePageLoad = function() {
	var loaded = pageLoadStore.getData().loaded;
}

var _handlePageChange = function() {
	var id = this.getAttribute('data-id');
	var popup;

	if (id === 'index') {
		dispatcher.dispatch({
			type: '3d:show'
		});
	} else if (id === 'specialists'
		|| id === 'catalog-item') {
		if (!cookieUtils.get('specialist')) {

			this._to = setTimeout(function() {
				popup = _findByDataId('popup-component', 'specialists-popup');
				if (!popup) return;
				dispatcher.dispatch({
					type: 'popup:toggle',
					id: 'specialists-popup'
				});
			}, Modernizr.mobile ? 3000 : 600);
		}
	}
}

elementProto.createdCallback = function() {
	this.mainStageReady = false;
	this.handleDispatcher = _handleDispatcher.bind(this);
	this.handlePopup = _handlePopup.bind(this);
	this.handlePageChange = _handlePageChange.bind(this);
}
elementProto.attachedCallback = function() {
	var id = this.getAttribute('data-id');
	var pw = document.getElementsByClassName('page-wrapper')[0];
	// var popup;

	dispatcher.dispatch({
		type: 'page:change',
		pageId: id
	});

	// if (this.mainStageReady)
	//  	this.handlePageChange();

	/*if (id === 'index') {
		dispatcher.dispatch({
			type: '3d:show'
		});
	} else if (id === 'specialists'
		|| id === 'catalog-item') {
		if (!cookieUtils.get('specialist')) {

			this._to = setTimeout(function() {
				popup = _findByDataId('popup-component', 'specialists-popup');
				if (!popup) return;
				dispatcher.dispatch({
					type: 'popup:toggle',
					id: 'specialists-popup'
				});
			}, 1000);
		}
	}*/
	if (id === 'p404') {
		pw.classList.add('p404-active');
	} else {
		pw.classList.remove('p404-active');
	}

	dispatcher.subscribe(this.handleDispatcher);
	popupStore.subscribe(this.handlePopup);
}
elementProto.detachedCallback = function() {
	dispatcher.unsubscribe(this.handleDispatcher);
	popupStore.unsubscribe(this.handlePopup);
}

document.registerElement('page-helper', {
	prototype: elementProto
});